import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import { Redirect, Link } from 'react-router-dom';
import * as QueryString from 'query-string';
import { Form, Row, Col, Image, ButtonGroup, Button } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import Storage from '../../support/Storage';
import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import ReCAPTCHA from 'react-google-recaptcha';

class ReceptoresSignIn extends Component {

  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    const query = QueryString.parse(this.props.location.search);

    const tipo = query.tipo ?? 'cliente'

    this.state = {
      data: {
        tipo: ['cliente', 'empleado'].includes(tipo) ? tipo : 'cliente',
      },
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.getRules({}))
    };

    this.recaptchaRef = createRef();
  }

  async componentDidMount() {
    let isLoggedIn = Auth.isAuthenticated();

    if (!Auth.isAuthenticated() && !!Auth.getUser()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);

        isLoggedIn = true;
      }
    } else {
      await Auth.logout();
    }

    if (isLoggedIn) {
      this.setState({
        isLoggedIn
      });
    } else {
      setTimeout(() => {
        this.setState({
          loaded: true
        });
      });
    }
  }

  getRules(data) {
    if (!!data.username && data.username.indexOf('@') === -1) {
      return {
        username: ['required', 'string', 'max:13', 'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9][A-Z,0-9][0-9,A-Z]$/', 'not_in:XAXX010101000,XEXX010101000'],
        password: ['required', 'min:8'],
      }
    }

    return {
      username: ['required', 'email'],
      password: ['required', 'min:8'],
    }
  }

  validate(data) {
    const message = 'No puedes iniciar sesión con un rfc genérico';
    const validator = new Validator(data, this.getRules(data), { not_in: message });

    validator.passes()

    this.setState({
      validator,
      error: null
    });

    if (validator.errors.first('username') === message) {
      this.setState({
        error: { 'message': validator.errors.first('username') }
      });
    }

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true,
      error: null
    });

    try {
      const token = await this.recaptchaRef.current.executeAsync();

      const params = {
        ...this.state.data,
        challenge: token
      }

      const query = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post('/receptores/auth/login/password', params, { headers });

      const { access_token, ...rest } = response;

      const user = {
        ...rest,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const { empresa, emisor, cliente } = rest;

      const data = {
        token: { access_token },
        user,
        empresa,
        emisor: emisor || {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        isLoggedIn: true,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  setTipoUsuario = (value) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        tipo: value
      }
    })
  }

  render() {
    const {
      data,
      isValid,
      isLoggedIn,
      busy,
      loaded,
      error,
    } = this.state;

    const rules = this.getRules(data);

    const query = QueryString.parse(this.props.location.search);

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/ext/receptores/facturas' } };

      if (from.pathname === '/ext/receptores/auth/login') {
        from.pathname = '/ext/receptores/facturas';
      }

      return <Redirect to="/bridge/receptores" state={ from } />;
    }

    if (!loaded) {
      return <Row></Row>
    }

    return (
      <Form autoComplete="off">

        <div className="auth-content">
          <div className="avatar mt-4">
            <Row className="auth-logo">
              <Col className="d-flex justify-content-start logo-container">
                  <Image src="/img/logo.png"
                    className="auth-logo-img"
                    fluid={ true }
                  />
                  <span>Facturotöpía</span>
              </Col>
            </Row>
          </div>

          <div className="login-content">
            <div className="mb-3">
              ¿Qué tipo de usuario eres?
            </div>

            <div id="output"></div>

            <div className="mb-2 text-center">
              <ButtonGroup className="mb-2">
                <Button variant={data.tipo === 'cliente' ? 'primary' : 'secondary'}
                  onClick={() => this.setTipoUsuario('cliente')}
                >
                  Soy cliente
                </Button>
                <Button variant={data.tipo === 'empleado' ? 'primary' : 'secondary'}
                  onClick={() => this.setTipoUsuario('empleado')}
                >
                  Soy empleado
                </Button>
              </ButtonGroup>
            </div>

            <div>
              {data.tipo === 'cliente' && (
                <p>Podrás descargar las <strong>Facturas</strong> que te han emitido en nuestro portal.</p>
              )}

              {data.tipo === 'empleado' && (
                <p>Podrás descargar los <strong>Recibos de Nómina</strong> que te han emitido en nuestro portal.</p>
              )}
            </div>

            <div className="form-box">
              <FormControl type="username"
                label={data.tipo === 'cliente' ? 'Email o RFC' : 'RFC'}
                name="username"
                autoFocus={ true }
                rules={ rules.username }
                value={ data.username }
                onChange={ this.handleOnChange }
              />

              <FormControl type="password"
                label="Contraseña"
                name="password"
                placeholder="*********"
                help=""
                rules={ rules.password }
                value={ data.password }
                onChange={ this.handleOnChange }
              />

              {data.tipo === 'empleado' && (
                <div className="my-2">
                  <strong>NOTA: </strong> Tu contraseña es tu número de empleado o tu número de seguridad social.
                </div>
              )}

              <ReCAPTCHA
                size="invisible"
                ref={ this.recaptchaRef }
                sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                onChange={ this.onCaptchaChange }
              />

              <Row>
                <Col className="text-right">
                  <LoadingButton type="button"
                    block={ true }
                    loading={ busy }
                    disabled={ !isValid || busy }
                    onClick={ this.handleOnSubmit }
                  >
                    { busy && 'Verificando...'}
                    { !busy && 'Continuar' }
                  </LoadingButton>
                </Col>
              </Row>

              <div className="pt-3">
              { !!error && this.renderError() }
              </div>

              <Row>
                <Col className="text-center">
                  <Link to={{ pathname: '/ext/receptores/password/email', search: !!query.tenancy ? `tenancy=${query.tenancy}` : '' }}>
                    Solicitar Invitación
                  </Link>
                </Col>
              </Row>

            </div>
          </div>

          <Row className="pt-4 pb-3">
            <Col>
              <small className="text-muted">
                Al continuar aceptas nuestros <a href="/">Términos del servicio</a> y nuestro <a href="/">Acuerdo de privacidad</a>
              </small>
            </Col>
          </Row>

        </div>
      </Form>
      )
    }
  }

  export default ReceptoresSignIn;